import { useThree } from '@react-three/fiber';
import Damsel from '../NewDamsel'
import Game from '../../classes/Game';
import { useEffect } from 'react';
import { Color } from 'three';
import Cursor from './Cursor'
import { withGame } from './helpers';


function Level({ game }: { game: Game }) {
  
  const { scene } = useThree()
  const level = game.getCurrentLevel()

  useEffect(() => {
    if(level) {
      scene.background = new Color(level.background)
      level.damsels.forEach((d) => {
        d.idle()
      })
    }
  }, [scene, level])

  if(!level) {
    return null
  }

  return <>
    <group>
      {level.damsels.map((d, i) => <Damsel key={i} damsel={d} onRegionClick={(location) => {
        game.updateTool(d, location)
      }}/>)} 
    </group>
    <Cursor heldTool={game.getHeldTool()} />
  </>


}

export default withGame(Level)


